// extracted by mini-css-extract-plugin
module.exports = {"container":"FJVipMark_container__3-QPA"};